import { useQuery } from '@apollo/client/react';
import { Box, BoxProps, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Button } from 'common/components/Button';
import { Link } from 'common/components/Link';
import { IRole, CurrentUserDocument } from 'graphql/types';
import { BillingPortalLink } from 'plans/components/BillingPortalLink';

export const PlanDemo = (props: BoxProps) => {
    const [translate] = useTranslation();
    const { data: currentUserData } = useQuery(CurrentUserDocument);
    const { currentUser } = currentUserData || {};
    const isOwner = currentUser?.roles?.includes(IRole.Owner);

    return (
        <Box {...props}>
            <Box sx={{ mt: 3 }}>
                <Stack direction="row" spacing={2}>
                    <Button
                        color="primary"
                        component={Link}
                        href={translate('planDemo.buttonLink')}
                        target="_blank"
                        variant="contained"
                    >
                        <Typography fontSize="1.6rem" fontWeight={700}>
                            {translate('planDemo.buttonText')}
                        </Typography>
                    </Button>

                    {isOwner && (
                        <Button
                            component={BillingPortalLink}
                            variant="contained"
                        >
                            {translate('planDemo.toBillingPortal')}
                        </Button>
                    )}
                </Stack>
            </Box>
        </Box>
    );
};
